import { isLevelName, LevelName } from "@/app/lib/levels/full-story";

const BASE_PATHS = [
    '/',
    '/tutorial',
    '/story',
    '/original',
    '/story/levels',
    '/story/tutorial'
] as const;

// This is all the basic paths, not including level names
export type BasePath = (typeof BASE_PATHS)[number];

// Now we build the paths for levels
// We need a way to convert their name types to kebabized syntax
// Thx chatgpt for this one:
// Recursively replace all spaces with "-":
type Kebabize<S extends string> =
    // Does S contain a space?
    S extends `${infer Head} ${infer Tail}`
        // Yes → replace one space with "-", then recurse on the rest
        ? `${Head}-${Kebabize<Tail>}`
        // No → return the string as-is
        : S;

export type KebabLevelName = Kebabize<LevelName>

// Path names that follow /story/level-name
type LevelPath = `/story/${KebabLevelName}`

// Make a union of both kinds
export type Path = BasePath | LevelPath;

const BASE_PATH_SET = new Set<string>(BASE_PATHS)
export function isPath(x: unknown) : x is Path {
    if (typeof x !== 'string')
        return false;

    if (BASE_PATH_SET.has(x))
        return true;

    if (!x.startsWith('/story/')) {
        return false;
    }

    const maybeKebabLevelName = x.slice('/story/'.length);
    const maybeLevelName = maybeKebabLevelName.replaceAll('-', ' ');
    return isLevelName(maybeLevelName);
}